import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GradesHubPage from "../pages/grades/hub/page";
import KindergartenPage from "../pages/grades/kindergarten/page";
import Grade1Page from "../pages/grades/grade-1/page";
import Grade2Page from "../pages/grades/grade-2/page";
import Grade3Page from "../pages/grades/grade-3/page";
import Grade4Page from "../pages/grades/grade-4/page";
import Grade5Page from "../pages/grades/grade-5/page";
import Grade6Page from "../pages/grades/grade-6/page";
import Grade7Page from "../pages/grades/grade-7/page";
import Grade8Page from "../pages/grades/grade-8/page";
import Grade9Page from "../pages/grades/grade-9/page";
import Grade10Page from "../pages/grades/grade-10/page";
import Grade11Page from "../pages/grades/grade-11/page";
import Grade12Page from "../pages/grades/grade-12/page";
import AlgebraRegentsPage from "../pages/grades/algebra-regents/page";
import GeometryTestsPage from "../pages/grades/geometry-tests/page";
import GeometryRegentsPage from "../pages/grades/geometry-regents/page";
import Algebra2TestsPage from "../pages/grades/algebra2-tests/page";
import PrecalcTestsPage from "../pages/grades/grade-12/tests/page";
import FreeLessonsPage from "../pages/free-lessons/page";
import AlgebraRegentsStudyPlanPage from "../pages/grades/algebra-regents-study-plan/page";
import WorksheetsPage from "../pages/worksheets/page";
import SuccessStoriesPage from "../pages/success-stories/page";
import DashboardPage from "../pages/dashboard/page";
import CertificatePage from "../pages/certificate/page";
import SATPrepPage from '../pages/sat-prep/page';
import AlgebraPracticePage from '../pages/sat-prep/algebra-practice/page';
import AdvancedMathPracticePage from '../pages/sat-prep/advanced-math-practice/page';
import ProblemSolvingPracticePage from '../pages/sat-prep/problem-solving-practice/page';
import GeometryTrigPracticePage from '../pages/sat-prep/geometry-trig-practice/page';
import MockExamPage from '../pages/sat-prep/mock-exam/page';
import StudyPlanPage from '../pages/sat-prep/study-plan/page';
import InformationIdeasPracticePage from '../pages/sat-prep/rw-information-ideas/page';
import CraftStructurePracticePage from '../pages/sat-prep/rw-craft-structure/page';
import ExpressionIdeasPracticePage from '../pages/sat-prep/rw-expression-ideas/page';
import StandardEnglishPracticePage from '../pages/sat-prep/rw-standard-english/page';
import ScoreHistoryPage from '../pages/sat-prep/score-history/page';
import MockExam2Page from '../pages/sat-prep/mock-exam-2/page';
import MockExam3Page from '../pages/sat-prep/mock-exam-3/page';
import MockExamRWPage from '../pages/sat-prep/mock-exam-rw/page';
import FullMockExamPage from '../pages/sat-prep/full-mock-exam/page';
import ThreeDModelingPage from '../pages/grades/grade-10/3d-modeling/page';
import GeometryRegentsTest2 from '../pages/grades/geometry-regents/GeometryRegentsTest2';
import GeometryRegentsTest3 from '../pages/grades/geometry-regents/GeometryRegentsTest3';
import PrecalculusPage from '../pages/grades/precalculus/page';
import APCalculusABPage from '../pages/grades/ap-calculus-ab/page';
import APCalculusBCPage from '../pages/grades/ap-calculus-bc/page';
import APStatisticsPage from '../pages/grades/ap-statistics/page';

const AlgebraRegentsOpenPage = lazy(() => import('../pages/grades/algebra-regents/AlgebraRegentsOpenPage'));
const Algebra2RegentsPage = lazy(() => import('../pages/grades/algebra2-regents/page'));
const Algebra2RegentsOpenPage = lazy(() => import('../pages/grades/algebra2-regents/Algebra2RegentsOpenPage'));
const PrecalcRegentsOpenPage = lazy(() => import('../pages/grades/precalc-regents/PrecalcRegentsOpenPage'));
const APCalculusReadinessPage = lazy(() => import('../pages/grades/ap-calculus-readiness/page'));
const APCalculusABExamPage = lazy(() => import('../pages/grades/ap-calculus-ab-exam/page'));
const GeometryRegentsOpenPage = lazy(() => import('../pages/grades/geometry-regents/GeometryRegentsOpenPage'));
const Grade8TestsPage = lazy(() => import('../pages/grades/grade-8-tests/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const ConstructionsPage = lazy(() => import('../pages/grades/grade-10/constructions/page'));

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-xl text-gray-600">Loading...</div></div>}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>,
  },
  {
    path: "/free-lessons",
    element: <FreeLessonsPage />,
  },
  {
    path: "/grades",
    element: <GradesHubPage />,
  },
  {
    path: "/grades/hub",
    element: <GradesHubPage />,
  },
  {
    path: "/grades/kindergarten",
    element: <KindergartenPage />,
  },
  {
    path: "/grades/grade-1",
    element: <Grade1Page />,
  },
  {
    path: "/grades/grade-2",
    element: <Grade2Page />,
  },
  {
    path: "/grades/grade-3",
    element: <Grade3Page />,
  },
  {
    path: "/grades/grade-4",
    element: <Grade4Page />,
  },
  {
    path: "/grades/grade-5",
    element: <Grade5Page />,
  },
  {
    path: "/grades/grade-6",
    element: <Grade6Page />,
  },
  {
    path: "/grades/grade-7",
    element: <Grade7Page />,
  },
  {
    path: "/grades/grade-8",
    element: <Grade8Page />,
  },
  {
    path: "/grades/grade-8-tests",
    element: <SuspenseWrapper><Grade8TestsPage /></SuspenseWrapper>,
  },
  {
    path: "/grades/grade-9",
    element: <Grade9Page />,
  },
  {
    path: "/grades/algebra-regents",
    element: <AlgebraRegentsPage />,
  },
  {
    path: "/grades/algebra-regents-study-plan",
    element: <AlgebraRegentsStudyPlanPage />,
  },
  {
    path: "/grades/algebra-regents-open",
    element: <SuspenseWrapper><AlgebraRegentsOpenPage /></SuspenseWrapper>,
  },
  {
    path: "/grades/grade-10",
    element: <Grade10Page />,
  },
  {
    path: "/grades/grade-10/constructions",
    element: <SuspenseWrapper><ConstructionsPage /></SuspenseWrapper>,
  },
  {
    path: "/grades/grade-10/3d-modeling",
    element: <ThreeDModelingPage />,
  },
  {
    path: "/grades/geometry-tests",
    element: <GeometryTestsPage />,
  },
  {
    path: "/grades/geometry-regents",
    element: <GeometryRegentsPage />,
  },
  {
    path: "/grades/geometry-regents-test-2",
    element: <GeometryRegentsTest2 />,
  },
  {
    path: "/grades/geometry-regents-test-3",
    element: <GeometryRegentsTest3 />,
  },
  {
    path: "/grades/geometry-regents-open",
    element: <SuspenseWrapper><GeometryRegentsOpenPage /></SuspenseWrapper>,
  },
  {
    path: "/grades/grade-11",
    element: <Grade11Page />,
  },
  {
    path: "/grades/grade-12",
    element: <Grade12Page />,
  },
  {
    path: '/grades/precalculus',
    element: <PrecalculusPage />,
  },
  {
    path: '/grades/ap-calculus-ab',
    element: <APCalculusABPage />,
  },
  {
    path: '/grades/ap-calculus-bc',
    element: <APCalculusBCPage />,
  },
  {
    path: '/grades/ap-statistics',
    element: <APStatisticsPage />,
  },
  {
    path: '/grades/algebra2-regents',
    element: <SuspenseWrapper><Algebra2RegentsPage /></SuspenseWrapper>,
  },
  {
    path: '/grades/algebra2-regents-open',
    element: <SuspenseWrapper><Algebra2RegentsOpenPage /></SuspenseWrapper>,
  },
  {
    path: '/grades/algebra2-tests',
    element: <Algebra2TestsPage />,
  },
  {
    path: '/grades/precalc-tests',
    element: <PrecalcTestsPage />,
  },
  {
    path: '/grades/precalc-regents-open',
    element: <SuspenseWrapper><PrecalcRegentsOpenPage /></SuspenseWrapper>,
  },
  {
    path: '/grades/ap-calculus-readiness',
    element: <SuspenseWrapper><APCalculusReadinessPage /></SuspenseWrapper>,
  },
  {
    path: "/grades/ap-calculus-ab-exam",
    element: <SuspenseWrapper><APCalculusABExamPage /></SuspenseWrapper>,
  },
  {
    path: "/worksheets",
    element: <WorksheetsPage />,
  },
  {
    path: "/success-stories",
    element: <SuccessStoriesPage />,
  },
  {
    path: '/forgot-password',
    element: <SuspenseWrapper><ForgotPasswordPage /></SuspenseWrapper>,
  },
  {
    path: '/reset-password',
    element: <SuspenseWrapper><ResetPasswordPage /></SuspenseWrapper>,
  },
  {
    path: '/certificate/:grade',
    element: <ProtectedRoute><CertificatePage /></ProtectedRoute>,
  },
  {
    path: '/sat-prep',
    element: <SATPrepPage />,
  },
  {
    path: '/sat-prep/algebra-practice',
    element: <AlgebraPracticePage />,
  },
  {
    path: '/sat-prep/advanced-math-practice',
    element: <AdvancedMathPracticePage />,
  },
  {
    path: '/sat-prep/problem-solving-practice',
    element: <ProblemSolvingPracticePage />,
  },
  {
    path: '/sat-prep/geometry-trig-practice',
    element: <GeometryTrigPracticePage />,
  },
  {
    path: '/sat-prep/mock-exam',
    element: <MockExamPage />,
  },
  {
    path: '/sat-prep/mock-exam-2',
    element: <MockExam2Page />,
  },
  {
    path: '/sat-prep/mock-exam-3',
    element: <MockExam3Page />,
  },
  {
    path: '/sat-prep/mock-exam-rw',
    element: <MockExamRWPage />,
  },
  {
    path: '/sat-prep/study-plan',
    element: <StudyPlanPage />,
  },
  {
    path: '/sat-prep/score-history',
    element: <ScoreHistoryPage />,
  },
  {
    path: '/sat-prep/rw-information-ideas',
    element: <InformationIdeasPracticePage />,
  },
  {
    path: '/sat-prep/rw-craft-structure',
    element: <CraftStructurePracticePage />,
  },
  {
    path: '/sat-prep/rw-expression-ideas',
    element: <ExpressionIdeasPracticePage />,
  },
  {
    path: '/sat-prep/rw-standard-english',
    element: <StandardEnglishPracticePage />,
  },
  {
    path: '/sat-prep/full-mock-exam',
    element: <ProtectedRoute><FullMockExamPage /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;